export const TOGGLE_STOPLISTONLY = 'TOGGLE_STOPLISTONLY'
